

import React, { useState, useEffect, useRef } from 'react';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import axios from "axios";
// import logo from "../../img/imglogo.png";
import { Link } from 'react-router-dom'
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import $ from 'jquery';
import { Spinner } from "react-bootstrap";
import './chatcss.css';

export default function Chat() {
  const [isRecording, setIsRecording] = useState(false);
  const [users, setUsers] = useState([]);
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  console.warn("ramraj", message)
  const [selectedFile, setSelectedFile] = useState(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isInputFocuseddd, setIsInputFocuseddd] = useState(false);
  const [recordedData, setRecordedData] = useState(null);
  const [recordurl, setRecordeurl] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isButtonDisabled1, setIsButtonDisabled1] = useState(false);
  const [loadingbutton, setLoadingbutton] = useState(false);
  const [loadingbuttonaudio, setLoadingbuttonaudio] = useState(false);
  const isButtonLoading = useRef(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const intervalRef = useRef(null);
  const user_id = localStorage.getItem("userid");
  const token = localStorage.getItem("token_store_cricket");

  const handleClick = () => {
    const element = document.querySelector('#cloesbtn');
    element.classList.add('display_none');
  };

  const recorderControls = useAudioRecorder()

  const addAudioElement = (blob) => {
    setIsRecording(false);
    const url = URL.createObjectURL(blob); // Create a URL for the recorded blob
    console.warn("Audio URL:", url);

    // Create and append the audio element
    const audio = document.createElement("audio");
    audio.src = url;
    audio.controls = true;
    document.body.appendChild(audio); // Optional: Add the audio to the body to preview it
    setRecordeurl(url); // Save the URL to state so it can be sent later
    sendMessageRecording(url); // Send the audio to the backend
  };


  const handleStartRecording = () => {
    setIsRecording(true);
  };

  useEffect(() => {
    $('.sendmessage').hide();
    loaduser();
    // window.scrollToBottom(0, 0);
    const interval = setInterval(() => {
      loaduser();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // ------------------------------Chat-List API---------------------------------------
  // const loaduser = async () => {

  //   try {
  //     setLoading(true);
  //     const formData = new FormData();

  //     formData.append("user_id", user_id);
  //     // alert(user_id)

  //     const apiUrl = `${process.env.REACT_APP_API_URL}chatlist`;

  //     const response = await fetch(apiUrl, {
  //       method: "post",
  //       data: formData,

  //       // headers: {
  //       //   Authorization: `Bearer ${token}`,
  //       //   "Content-Type": "application/json",
  //       // },
  //     });

  //     const result = await response.json();
  //     // console.warn(result.data);
  //     setUsers(result.data);
  //   } catch (error) {
  //     console.error("There was a problem with the fetch operation:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
  const loaduser = async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("user_id", user_id);

      const apiUrl = `${process.env.REACT_APP_API_URL}chatlist`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData, // Use 'body' instead of 'data'
        headers: {
          Authorization: `Bearer ${token}`, // Ensure token is defined
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setUsers(result.data);
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    } finally {
      setLoading(false);
    }
  };

  const onRecordStart = () => {
    setIsRecording(true);
  };

  const onRecordStop = (recordedBlob) => {
    setIsRecording(false);
    setRecordedData(recordedBlob.blob);
    console.log(recordedBlob);
  };
  const OnnumberChange = (e) => {
    $('.sendmessageMic').hide();
    $('.sendmessage').show();
    const mobilnumbers = e.target.value;
    setMessage(mobilnumbers);
    setIsInputFocused(mobilnumbers);

  };

  const onFileChange = (e) => {
    // Handle file selection (image, audio, video)

    $('.sendmessageMic').hide();
    $('.sendmessage').show();
    const file = e.target.files[0];
    setSelectedFile(file);
    setIsInputFocused(file);

  };

  const sendMessageRecording = async (recordurl1) => {
    if (!recordurl1) {
      toast.error("No audio recorded!");
      return;
    }

    setIsButtonDisabled1(true); // Disable button while sending the request
    setLoadingbuttonaudio(true); // Show loading spinner

    const formData = new FormData();
    formData.append("message", message); // The text message (if any)
    formData.append("user_id", user_id); // The user ID
    formData.append("type", "audio"); // Message type
    formData.append("file", recordurl1); // Append the recorded audio file

    try {
      const response = await axios.post(
        `https://khelogalifaridabad.com/kgfkadmin/public/api/chatstore-audio`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Authentication
            "Content-Type": "multipart/form-data", // Specify the content type as form-data
          },
        }
      );

      if (response.data.success === 1) {
        toast.success(response.data.message);
        setMessage(""); // Clear message input
        setSelectedFile(null); // Clear selected file (if any)
        setRecordeurl(null); // Clear the audio URL
        loaduser(); // Refresh chat list
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error sending audio:", error);
      toast.error("An error occurred while sending the audio.");
    } finally {
      setLoadingbuttonaudio(false); // Hide loading spinner
      setIsButtonDisabled1(false); // Enable the button again
    }
  };


  const handleClicksend = () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true);
      sendMessage();

      // Clear previous interval
      clearInterval(intervalRef.current);

      // Set a new interval to reset isButtonClicked after 3 seconds
      intervalRef.current = setInterval(() => {
        clearInterval(intervalRef.current);
        setIsButtonClicked(false);
      }, 3000);
    }
  };


  // -------------------------------------Chat-Store-Api-------------------------------------------
  const sendMessage = () => {
    setIsButtonDisabled(true);
    if (isRecording) {
      console.log('Recorded Data:', recordedData);
    } else {
      // Handle sending a regular text message
      // ...
    }

    const user_id = localStorage.getItem("userid");
    // alert(recordurl);
    // if (message.trim() === "" && !selectedFile && !recordurl) {
    //   toast.error("Please enter a message or select a file before sending.");
    //   return;
    // }
    if (!isButtonLoading.current) {
      isButtonLoading.current = true;

      setIsButtonDisabled(true);
      // setTimeout(() => {
      setIsButtonDisabled(false);
      isButtonLoading.current = false;
      // }, 1000);
    }
    try {
      setLoadingbutton(true);
      const formData = new FormData();
      // formData.append("message", message);
      formData.append("user_id", user_id);

      // formData.append("department", 'deposit');
      // formData.append("sendertype", 'user');
      if (selectedFile) {
        formData.append("message", selectedFile);
        formData.append("type", 'image');
      }
      if (recordurl) {
        // console.warn(recordurl)
        formData.append("file", recordurl);
        formData.append("type", 'audio');
      }
      if (message) {
        // console.warn(recordurl)
        formData.append("message", message);
        formData.append("type", 'text');
      }

      let url = ` https://khelogalifaridabad.com/kgfkadmin/public/api/chatstore`;

      // Configure the request
      const config = {
        method: "POST",
        url: url,
        data: formData,
        // headers: {
        //   Authorization: `Bearer ${token}`,
        //   "Content-Type": "application/json",
        // },
      };

      axios.post(url, formData, config).then(function (response) {
        const res = JSON.stringify(response.data);
        // alert("adfasd")
        setMessage("");
        setSelectedFile("");
        setRecordeurl("");

        if (response.data.success == 1) {
          console.warn("rrrrrrrrrrrrr", response.data.message);
          setMessage("");
          // setSelectedFile("");
          // setRecordeurl("");
          // setIsInputFocused(true);
          $('.sendmessageMic').show();
          $('.sendmessage').hide();
          toast.success(response.data.message, {
            onClose: () => {
              setTimeout(() => {
                loaduser();
              }, 1000);
            },
          });

          // window.location.reload();
        } else {
          toast.error(response.data.message);

        }
      });
    } catch (error) {
      console.error("User Name Update:", error);
    }
    finally {
      setLoadingbutton(false);
    }
  };


  return (
    <>
      {isRecording ? (<><div className='bg-mic' id='cloesbtn'>
        <button className='btn btn-close-custum' onClick={handleClick}>X</button>

        <div
          className='voicechange'>
          {/* <img src={mic} className='mic' /> <VoiceRecorder onClick={handleStopRecording} /></div></div></>) : (<></>)} */}
          {/* <img src={mic} className='mic' />   */}
          {/* <AudioRecorder
            onRecordingComplete={(blob) => addAudioElement(blob)}
            recorderControls={recorderControls}
          /> */}
          {/* <button className='btn' onClick={recorderControls.stopRecording}><span className='block-red'></span></button> */}

        </div></div></>
      ) : (
        <></>
      )}
      <main id="main" class="main new_chat">
        <section className="message-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="chat-area">
                  {/* chatbox */}
                  <div className="chatbox">
                    <div className="modal-dialog-scrollable">
                      <div className="modal-content">
                        <div className="modal-body">
                          <div className="msg-body">
                            <ul>
                              {users && users.map((value) => (
                                <div className={`message-container ${value.sender === 'reply' ? 'messageadmin' : ''}`} key={value.id}>
                                  <div>
                                    <div className={`${value.sender === 'user' ? 'user-message' : 'admin-message'}`}>
                                      {/* Handling different chat types */}
                                      {value.type === 'text' ? (
                                        <li className={value.sender === 'user' ? 'reply' : 'sender'}>
                                          <p className='text-white' style={{ wordBreak: 'break-word' }}>
                                            {value.message ? value.message : value.message}
                                          </p>
                                          <span className="time">
                                            {new Date(value.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                          </span>
                                        </li>
                                      ) : value.type === 'image' ? (
                                        <>
                                          <img
                                            src={`https://khelogalifaridabad.com/kgfkadmin/public/backend/uploads/chatimage/${value.message}`}
                                            alt="Uploaded"
                                            style={{ maxWidth: "100px", height: "auto" }}
                                          />
                                          <span className="time">
                                            {new Date(value.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                          </span>
                                        </>
                                      ) : value.type === 'video' ? (
                                        <video controls width="100%" height="150px">
                                          <source src={value.url} />
                                        </video>
                                      ) : value.type === 'audio' ? (
                                        <div className="audio-message">
                                          <audio controls className="audioclass">
                                            <source
                                              src={`https://khelogalifaridabad.com/kgfkadmin/public/backend/uploads/chatimage/${value.message}`}
                                              type="audio/mpeg"
                                            />
                                          </audio>
                                          <span className="time">
                                            {new Date(value.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                          </span>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))}





                            </ul>
                          </div>
                        </div>
                        <div className="send-box">
                          <div className="inputchat">

                          </div>
                          <form action="">
                            <textarea
                              className="form-control"
                              aria-label="message…"
                              placeholder="Write message…"
                              onChange={OnnumberChange}
                              value={message + (selectedFile ? ` - ${selectedFile.name}` : "")} // Display selected file name
                            />

                            <div className="buttonsend bg-info">
                              <label
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <i
                                  className="bi bi-paperclip"
                                  style={{ transform: "rotate(60deg)", fontSize: "30px" }}
                                ></i>
                                <label htmlFor="multipleFileInput"></label>
                                <input
                                  type="file"
                                  onChange={onFileChange}
                                  id="multipleFileInput"
                                  style={{ display: "none" }}
                                />
                              </label>
                            </div>
                            <div className="buttonsend">
                              <div className="buttonsend">
                                <div className="sendmessage">
                                  <i onClick={handleClicksend} disabled={isButtonClicked} className="bi bi-send message_send">{isButtonClicked && <Spinner />}</i>
                                </div>
                                {!message && !selectedFile && (                                  <div className="sendmessageMic">
                                    <AudioRecorder
                                      onRecordingComplete={(blob) => addAudioElement(blob)}
                                      recorderControls={recorderControls}
                                    />
                                    <div className='sendmessagebtn'>
                                      <i
                                        onClick={recorderControls.stopRecording}
                                        disabled={loadingbuttonaudio || isButtonDisabled1}
                                        className="bi bi-send"
                                      >
                                        {loadingbuttonaudio && <Spinner />}
                                      </i>
                                    </div>
                                  </div>
                                )}


                              </div>
                            </div>
                          </form>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

    </>
  );
}
